// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-21379a2a],.v-card>h2[data-v-21379a2a]{color:#1e88e5;font-weight:700}a[data-v-21379a2a]{text-decoration:none}.right[data-v-21379a2a]{float:right}.v-card p[data-v-21379a2a]{text-align:center}.v-card .v-image[data-v-21379a2a]{-webkit-transform:translate(-50%);transform:translate(-50%);left:50%;opacity:.6}.icon-image[data-v-21379a2a]{opacity:.5;float:right}.white[data-v-21379a2a]{-webkit-filter:invert(1);filter:invert(1);mix-blend-mode:lighten}", ""]);
// Exports
module.exports = exports;
